export default {
  id : 'ps.StoreTrafficQueryHandler',
  matches : {
    objectType : 'store',
    client : 'ps.StoreTrafficEvents'
  },
  handle( cxt ) {

    return {
      where : [
        [ '$data/analyticsType', '=', 'traffic' ],
        [ '$data/featureName', '=', 'entry' ]
      ]
    }
  }
}
